
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlW as ObiOwnShipControlWElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-w.js';
 
 
 

 
 export const ObiOwnShipControlW = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-w',
   elementClass: ObiOwnShipControlWElement,
   events: {
     
   }
  });
 
 